import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Percent from './percent';

export function CommissionPercent({ deal }) {
  return (
    <Percent
      label="Commission %"
      name="grossCommission"
      value={deal.grossCommissionPercent}
    />
  );
}

CommissionPercent.propTypes = {
  deal: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(CommissionPercent);
